import { ApiBase } from './api-base';

export class OfficeApi extends ApiBase {
  getOffices = () => this.apiClient.sendRequest({
    method: 'GET',
    url: 'offices/',
  });
}
